
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#006FCF","d":"m14.026 4.12.537-1.503 2.442-.005-.003-1.614a1 1 0 0 0-1-.998H1a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h15.005a1 1 0 0 0 1-1v-1.579l-2.302.005-.856-1.03-.89 1.03H6.374V8.94H4.202l2.715-6.322h2.642l.638 1.434V2.617h3.28zm-1.853.996V4.51l.219.605 1.091 3h1.086l1.097-3 .213-.599v3.599l1.126-.005V3.504l-1.882.005-.862 2.338-.23.633-.235-.633-.867-2.338H11.03v4.607h1.142zm-2.457 3h1.315l-1.97-4.607H7.533L5.55 8.116H6.85l.347-.887h2.172zM8.059 5.07l.224-.576.224.576.464 1.163H7.594zm-.767 3.875v4.589h3.74v-.996H8.433v-.8h2.547v-.991H8.434V9.94h2.597v-.996zm7.898 4.589h1.484L14.58 11.23l2.094-2.286h-1.461l-1.35 1.491-1.343-1.491h-1.489l2.088 2.303-2.088 2.286h1.444l1.36-1.497zm.566-2.31 1.249 1.32V9.913z"}})])
          )
        }
      }
    